// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1nB9d";
var _4 = "inner-3xBpl";
var _5 = "leftSlot-ffdei";
var _6 = "centerSlot-2cSfK";
var _7 = "rightSlot-2iJku";
var _8 = "equalSlotsBasis-nBGKA";
var _9 = "backwardButton-1yNS4";
var _a = "closeText-2lTLs";
var _b = "closeWrapper-kHkYM";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "inner", _5 as "leftSlot", _6 as "centerSlot", _7 as "rightSlot", _8 as "equalSlotsBasis", _9 as "backwardButton", _a as "closeText", _b as "closeWrapper" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "inner": _4, "leftSlot": _5, "centerSlot": _6, "rightSlot": _7, "equalSlotsBasis": _8, "backwardButton": _9, "closeText": _a, "closeWrapper": _b }
